import React from 'react'
import './contactUs.css'
import contactUs from './contactUs.svg'

export const ContactUs = () => {
  return (
    <div className='contactUs'>
        <img src={ contactUs } alt="" />
        <div>
            <p>Want to get in touch?</p>
            <a href="#"><button>Contact Us</button></a>
        </div>
    </div>
  )
}
